var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        {
          staticClass: "otr-line-spacing__30",
          attrs: { gutter: 20, width: "100%" },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("search-box", {
                attrs: {
                  placeholder: "Keyword Search: ID / Title / Description",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search(1)
                  },
                },
                model: {
                  value: _vm.query.q,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "q", $$v)
                  },
                  expression: "query.q",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c(
                "el-select",
                {
                  ref: "status",
                  staticClass: "filter-item",
                  attrs: { placeholder: "Status", clearable: "" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.search(1)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.disableVisble("status")
                    },
                  },
                  model: {
                    value: _vm.query.publish,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "publish", $$v)
                    },
                    expression: "query.publish",
                  },
                },
                _vm._l(_vm.trainingStatus, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 7 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.search(1)
                    },
                  },
                },
                [_vm._v("Search")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: { path: "/loop/create" } } },
                [
                  _c("el-button", { attrs: { type: "success" } }, [
                    _vm._v("Create"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading.body",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                      modifiers: { body: true },
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.loopList,
                    fit: "",
                    "highlight-current-row": "",
                    height: _vm.height,
                  },
                  on: { "sort-change": _vm.sort },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "ID", fixed: "", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.isExipred(scope.row.end.utc)
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [_vm._v("Expired")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(scope.row.id))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Title",
                      fixed: "",
                      width: "250",
                      sortable: "custom",
                      prop: "title",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              { staticClass: "otr-word-break" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: { to: "/loop/edit/" + scope.row.id },
                                  },
                                  [_c("u", [_vm._v(_vm._s(scope.row.title))])]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Internal Title",
                      fixed: "",
                      width: "250",
                      sortable: "custom",
                      prop: "internal.title",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "otr-word-break" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getInternalTitle")(scope.row.internal)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Tenant", fixed: "", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getTenantLabel")(
                                    scope.row.metadata.tenant
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: { width: "100", sortable: "custom", prop: "type" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.type))]),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _vm._v("\n            Type\n          "),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        width: "150",
                        sortable: "custom",
                        prop: "start",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      scope.row.start.utc,
                                      "YYYY-MM-DD HH:mm"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { color: "blue" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      scope.row.start.local,
                                      "YYYY-MM-DD HH:mm"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [_vm._v("UTC Start Time /")]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { color: "blue" } }, [
                          _vm._v("Local Start Time"),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "End Time",
                        width: "150",
                        sortable: "custom",
                        prop: "end",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      scope.row.end.utc,
                                      "YYYY-MM-DD HH:mm"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { color: "blue" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      scope.row.end.local,
                                      "YYYY-MM-DD HH:mm"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("div", [_vm._v("UTC End Time /")]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { color: "blue" } }, [
                          _vm._v("Local End Time"),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Manager", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "otr-word-break" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("getProducerStaff")(
                                    scope.row.staff,
                                    _vm.staffList
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Status",
                      width: "100",
                      sortable: "custom",
                      prop: "publish",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.publish))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Updated At",
                      width: "120",
                      sortable: "custom",
                      prop: "updatedAt",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFormat")(
                                    scope.row.updatedAt,
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "480" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "router-link",
                              { attrs: { to: "/loop/edit/" + scope.row.id } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "Edit",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { padding: "10px 10px" },
                                        attrs: { type: "primary" },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "edit" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "Copy Loop",
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { padding: "10px 10px" },
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDrawer(
                                          scope.row.id,
                                          scope.row.title
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-document-copy",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              { attrs: { to: "/loop/enroll/" + scope.row.id } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "Enrollment List",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { padding: "10px 10px" },
                                        attrs: { type: "primary" },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "hiker" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "Delete Loop",
                                  placement: "top",
                                },
                              },
                              [
                                _vm.checkPermission([
                                  "root",
                                  "otr-digital-producer",
                                ])
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { padding: "10px 10px" },
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteLoop(
                                              scope.row.id,
                                              scope.row.title
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete-solid",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.query.page,
                      "page-sizes": [10, 20, 30, 50, 100],
                      "page-size": _vm.query.limit,
                      "pager-count": 5,
                      total: _vm.total,
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.checked.drawTitle,
            visible: _vm.copyDrawer,
            direction: "ttb",
            "before-close": _vm.handleDrawClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.copyDrawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "20px" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.genneralInfo,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "genneralInfo", $$v)
                    },
                    expression: "checked.genneralInfo",
                  },
                },
                [_vm._v("General Info")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.salesForce,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "salesForce", $$v)
                    },
                    expression: "checked.salesForce",
                  },
                },
                [_vm._v("Salesforce")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.eventTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "eventTime", $$v)
                    },
                    expression: "checked.eventTime",
                  },
                },
                [_vm._v("Event Time")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.welcomeResourceSetting,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "welcomeResourceSetting", $$v)
                    },
                    expression: "checked.welcomeResourceSetting",
                  },
                },
                [_vm._v("Welcome Resource Setting")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.programs,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "programs", $$v)
                    },
                    expression: "checked.programs",
                  },
                },
                [_vm._v("Programs")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.staffs,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "staffs", $$v)
                    },
                    expression: "checked.staffs",
                  },
                },
                [_vm._v("Staffs")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.checked.emailSettings,
                    callback: function ($$v) {
                      _vm.$set(_vm.checked, "emailSettings", $$v)
                    },
                    expression: "checked.emailSettings",
                  },
                },
                [_vm._v("Email Settings")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "40px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { padding: "10px 10px" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.copy },
                    },
                    [_vm._v("Copy")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }